import { createFileRoute } from '@tanstack/react-router';
import CompanyOverview from '@/modules/companies/pages/CompanyOverview';

import { Route as CompanyPageRoute } from './route';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/companies/$companyId/',
)({
  head: () => ({
    meta: [{ title: 'Visão Geral da Empresa' }],
  }),
  component: function CompanyOverviewPage() {
    const company = CompanyPageRoute.useLoaderData();

    return <CompanyOverview company={company} />;
  },
});
